import { Component, useEffect } from 'react'
import Lenis from 'lenis'
import Hero from './components/Hero'
import Marquee from './components/Marquee'
import Philosophy from './components/Philosophy'
import Principles from './components/Principles'
import Moment from './components/Moment'
import FinalCta from './components/FinalCta'
import Footer from './components/Footer'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }
  static getDerivedStateFromError() {
    return { hasError: true }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-paper px-6 text-center">
          <p className="display-m text-ink">No More Bluff</p>
          <p className="mt-3 text-sm text-haze">Built to keep you going. (Something hiccuped — refresh in a moment.)</p>
        </div>
      )
    }
    return this.props.children
  }
}

export default function App() {
  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduced) return
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    })
    window.__lenis = lenis
    let raf
    const loop = (time) => {
      lenis.raf(time)
      raf = requestAnimationFrame(loop)
    }
    raf = requestAnimationFrame(loop)
    return () => {
      cancelAnimationFrame(raf)
      lenis.destroy()
      window.__lenis = undefined
    }
  }, [])

  return (
    <ErrorBoundary>
      <div className="bg-paper font-body text-ink">
        <div className="grain" aria-hidden="true" />
        <main>
          <Hero />
          <Marquee />
          <Philosophy />
          <Principles />
          <Moment />
          <FinalCta />
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  )
}
